import { generateAssets } from "@/utils/GenerateAssets.ts";

export const MarkingBundle = {
    mainBg: {
        alias: "mainbg",
        src: "img/student/marking-activity/main-bg.png"
    },
    door: {
        alias: "door",
        src: "img/student/marking-activity/door.png"
    },
    vines: {
        alias: "vines",
        src: "img/student/marking-activity/vines.png"
    },
    track1: {
        alias: "track1",
        src: "img/student/marking-activity/track1.png"
    },
    track2: {
        alias: "track2",
        src: "img/student/marking-activity/track2.png"
    },
    track3: {
        alias: "track3",
        src: "img/student/marking-activity/track3.png"
    },
    beetle: {
        alias: "beetle",
        src: "img/student/marking-activity/beetle.png"
    },
    tile1: {
        alias: "tile1",
        src: "img/student/marking-activity/tile1.png"
    },
    tile2: {
        alias: "tile2",
        src: "img/student/marking-activity/tile2.png"
    },
    tile3: {
        alias: "tile3",
        src: "img/student/marking-activity/tile3.png"
    },
    tile4: {
        alias: "tile4",
        src: "img/student/marking-activity/tile4.png"
    },
    splitBtn1: {
        alias: "splitBtn1",
        src: "img/student/marking-activity/split-btn-1.png"
    },
    splitBtn2: {
        alias: "splitBtn2",
            src: "img/student/marking-activity/split-btn-2.png"
    },
    splitBtn3: {
        alias: "splitBtn3",
        src: "img/student/marking-activity/split-btn-3.png"
    },
    star: {
        alias: "guardianstar",
        src: "img/student/marking-activity/star.svg"
    },
    nonsense: {
        alias: "nonsense",
        src: "img/student/marking-activity/nonsense.svg"
    },
    sweaterschoolreg: {
        alias:"sweaterschoolreg",
        src:"/fonts/sweaterschoolreg.ttf"
    },
    rhdicons: {
        alias:"rhdicons",
        src:"/fonts/rhdicons.ttf"
    },
};

export const MarkingAssets = generateAssets(MarkingBundle);
